var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;



//////////////////
// WEBPACK FOOTER
// ./~/victory-stack/~/lodash/_Uint8Array.js
// module id = ./node_modules/victory-stack/node_modules/lodash/_Uint8Array.js
// module chunks = 1